import Game from '../Game';

export function formatStrikePrice(props: {
    price: string;
    priceUsd: number;
    strikePriceUsd: number;
}): string {
    const parsed = parseCurrency(props.price);

    if (!parsed) {
        return '';
    }

    const { beforeValue, value, afterValue } = parsed;
    const multiplier = value / props.priceUsd;
    const strikePrice = props.strikePriceUsd * multiplier;
    const strikePriceFormatted = strikePrice.toLocaleString(Game.sdk.getLanguage(), { maximumFractionDigits: 2, minimumFractionDigits: 2 });

    return `${beforeValue}${strikePriceFormatted}${afterValue}`;
}

export function parseCurrency(input: string) {
    const regex = new RegExp(
        '(.*?)' + // capture anything (non-greedy) before the numbers part
        '(' + // capture the numbers part
        '\\d+' + // starts with digits
        '(?:' +
        '[\\,\\.\\ ]*\\d+' + // ends with digits, might contain comma, period and space
        ')*' + // this might repeat several times or be missing at all
        ')' +
        '(.*)' // capture anything after the numbers part
    );

    const regexMatch = input?.match(regex);
    if (!regexMatch) return null;

    const beforeValue = regexMatch[1];
    const numbersPart = regexMatch[2];
    const afterValue = regexMatch[3];

    // FIXME: fix 5,000 parsed as 5
    const temp = numbersPart.split(/[\,\.]/);
    const fractionPart = temp.length > 1 ? temp.pop() : '0';
    const fullPart = temp.join('');

    const value = Number(`${withoutSpaces(fullPart)}.${withoutSpaces(fractionPart)}`);

    // TODO: preserve formatting in reconstructer price (delimiters and spaces)
    return { beforeValue, value, afterValue };

    function withoutSpaces(input: string) {
        return input.replace(/\ /g, '');
    }
}
